// Copyright (c) 2020-2022 Visual Intelligence LP. All rights reserved.
//
import { injectable } from 'inversify';
import { observable, computed, action, makeObservable } from 'mobx';

import container from '@core/di';
import { QRCodeService } from '@shared/services';


// Expose methods provided by the service component.
@injectable()
export default class QRCodeStore  {
  static diToken = Symbol('qrcode-store');
  private service = container.get<QRCodeService>(QRCodeService.diToken);
  // stateful arrays for qr codes.
  @observable _listQRCodes: Array<string> = [];
  @observable loading = false;

  constructor() {
    makeObservable(this);
  }

  // Update a qr code.
  // Input:
  // Return:
  //   response from the update request.
  @action updateQRCode = (qrCode: string , qrStatus: string): Promise<string | undefined> => {
    return this.service.updateQRCode(qrCode, qrStatus);
  }

  // Add a qr code.
  // Input:
  // Return:
  //   response from the update request.
  @action addQRCode = (qrCode: string): Promise<string | undefined> => {
    return this.service.addQRCode(qrCode);
  }

  // Delete a qr code.
  // Input:
  // Return:
  //   response from the update request.
  @action deleteQRCode = (qrCode: string): Promise<string | undefined> => {
    return this.service.deleteQRCode(qrCode);
  }

  // Fetch the lists the qr codes.
  // Note: caller will use the 'get' method for a list name to access the individual lists.
  // Return:
  //   Array of qr codes.
  @action getQRCodes = async (): Promise<Array<string> | undefined> => {
    this.loading = true;

    try {
      const dataFromRest = await this.service.getQRCodes();

      // Parse the array of lists into the lists for loading into the form.
      if(dataFromRest !== undefined && dataFromRest.length > 3) {
        this._listQRCodes = dataFromRest;

      }
      
      this.loading = false;

      console.log("****** getQRCode rc:",dataFromRest);

      return dataFromRest;
    } 
    catch (err) {
      this.loading = false;
    }
  }

  // Check if a string is a valid QR code.
  // Input:
  //   qrCode: string to check.
  // Return: true if the string is a valid QR code.
  @action checkQRCode = async (qrCode: string): Promise<boolean> => {
    const qrCodes = await this.getQRCodes();
    if(qrCodes !== undefined) {
      if(qrCodes.indexOf(qrCode) > -1) {
        return true;
      }
    }
    return false;
  }

  // Return the customer/order/asset lists as props.
  @computed get listQRCodes() {
    return this._listQRCodes;
  }

  // Clear the stateful lists.
  @action resetList = () => {
    this._listQRCodes = [];
  }
}